import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  wrapperGoogleMap: {
    position: "relative",
    borderRadius: "1rem",
    overflow: "hidden",
    height: "100%",
    minHeight: "500px",
    width: "100%",
  },

  infoWindowContainer: {
    position: "absolute",
    transform: "translate(-50%, -215%)",
    zIndex: 10,
  },
  infoWindow: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: "8px",
    padding: "20px 16px",
    width: "270px",
    display:'flex',
    flexDirection:'column',
    gap:'12px'
  },

  containerRowInfo: {
    display: "flex",
    flexDirection: "column",
  },
  titleInfo: {
    color: theme.palette.text.secondary,
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "24px",
  },
  title: {
    color: theme.palette.text.secondary,
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
  },
  containerAvatarName: {
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    alignItems: "center",
  },
  defaultAvatarWithNameStyle: {
    fontSize: "12px",
    fontWeight: 600,
    lineHeight: "18.667px",
    backgroundColor: theme.palette.background.tertiary,
    color: theme.palette.text.disabled,
    border: `0.5px solid  rgba(0, 0, 0, 0.08)`,
  },
}));
